import { AxiosResponse } from "axios";

import { api } from "./api";

export const reportService = {
  async downloadBillingReport(
    startDate: string,
    endDate: string
  ): Promise<AxiosResponse<Blob>> {
    const url = "/Portal/Report/GenerateBillingReport";

    const serverResponse = await api.post(
      url,
      {
        fromDate: startDate,
        toDate: endDate,
      },
      { responseType: "blob" }
    );

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async downloadPatientReport(
    patientId: number,
    startDate: string,
    endDate: string
  ): Promise<AxiosResponse<Blob>> {
    const url = "/Portal/Report/GeneratePatientReport";

    const serverResponse = await api.post(
      url,
      {
        patientId,
        fromDate: startDate,
        toDate: endDate,
      },
      { responseType: "blob" }
    );

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  async downloadDischargeSummaryReport(
    patientId: number
  ): Promise<AxiosResponse<Blob>> {
    const url = "/Portal/Report/GenerateDischargeSummaryReport";

    const serverResponse = await api.post(
      url,
      { patientId },
      { responseType: "blob" }
    );

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },

  // EN-4852: export a single spirometry session as a PDF. The backend keys the
  // export on the session id (shared by every blow in the session) and returns
  // the PDF blob directly.
  async downloadSpirometrySessionReport(
    sessionId: string
  ): Promise<AxiosResponse<Blob>> {
    const url = `/Portal/SpirometryTest/ExportSessionPdf/${sessionId}`;

    const serverResponse = await api.get(url, { responseType: "blob" });

    if (serverResponse !== undefined) {
      return serverResponse;
    }

    throw Error;
  },
};
